<template>
  <el-select :placeholder="placeholder" :value="content" @change="handleChange">
    <el-option :value="undefined" :label="placeholder"></el-option>
    <el-option v-for="(item, index) in records" :key="index" :value="item.value" :label="item.name">
    </el-option>
  </el-select>
</template>
<script>
import {getAction} from '@/api/manage'

export default {
  name: 'SDictSelect',
  props: {
    triggerChange: Boolean,
    placeholder: String,
    value: [String, Number],
    code: String
  },
  data() {
    return {
      records: [],
      url: '/home/selectDictItemByCode'
    }
  },
  watch: {
    code: {
      immediate: true,
      handler() {
        this.selectDictItemByCode()
      },
    }
  },
  created() {
  },
  computed: {
    content() {
      return this.value != null ? this.value.toString() : undefined
    }
  },
  methods: {
    selectDictItemByCode() {
      const _this = this
      getAction(_this.url, {code: _this.code}).then(res => {
        if (res.success) {
          _this.records = res.result;
        }
      })
    },
    handleChange(value) {
      if (this.triggerChange) {
        this.$emit('change', value);
      } else {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style scoped>

</style>
